import React from 'react';
import WorkoutCard from './WorkoutCard';
import EmptyState from './EmptyState';
import { getWorkoutName } from '../../utils/programUtils';

const WorkoutContainer = ({ 
  tabId, 
  tabLabel, 
  workouts, 
  programName,
  onRemoveWorkout 
}) => {
  const scrollLeft = () => {
    const container = document.getElementById(`workout-container-${tabId}`);
    if (container) {
      const scrollAmount = container.clientWidth / 3;
      container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    const container = document.getElementById(`workout-container-${tabId}`);
    if (container) {
      const scrollAmount = container.clientWidth / 3;
      container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  const showNavButtons = workouts.length > 3;

  return (
    <div className="w-5/6 relative">
      {showNavButtons && (
        <>
          <button
            onClick={scrollLeft}
            className="absolute left-2 top-10 z-10 bg-white shadow-lg rounded-full p-2 border border-gray-300 hover:bg-gray-50 transition-all duration-200"
            title="Scroll izquierda"
          >
            <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button
            onClick={scrollRight}
            className="absolute right-2 top-10 z-10 bg-white shadow-lg rounded-full p-2 border border-gray-300 hover:bg-gray-50 transition-all duration-200"
            title="Scroll derecha"
          >
            <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </>
      )}
      
      <div 
        id={`workout-container-${tabId}`}
        className="h-full overflow-x-auto scrollbar-visible"
        style={{
          scrollbarWidth: 'auto',
          scrollbarColor: '#9CA3AF #F3F4F6'
        }}
      >
        <div className="flex h-full min-w-full">
          {workouts.length > 0 ? (
            workouts.map((workout, index) => (
              <WorkoutCard
                key={workout.id}
                workout={workout}
                workoutName={getWorkoutName(programName, tabLabel, index)}
                onRemove={onRemoveWorkout}
              />
            ))
          ) : (
            <div className="flex-1 flex items-center justify-center">
              <EmptyState
                icon="💪"
                title="No workouts created"
                subtitle="Click on &quot;Add Workout&quot;"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WorkoutContainer;